import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { Link } from 'react-router-dom';
import { InjectedTransitionedContainerProps } from 'src/_context/TransitionedContainer';
import logo from 'src/assets/logos/novo-logo-light.svg';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import { Language } from 'src/utils/Languages';

export type LogoProps = {};
const styles = {
    logo: {
        width: 80,
        [responsive.Desktop]: {
            width: 120,
        }
    },
    logoPositioning: {
        [responsive.Mobile]: {
            margin: `0 ${spacing.Gutter.Mobile}px  ${spacing.Gutter.Mobile}px  ${spacing.Gutter.Mobile}px`
        },
        [responsive.Tablet]: {
            margin: `0 ${spacing.Gutter.Tablet}px  ${spacing.Gutter.Tablet}px  ${spacing.Gutter.Tablet}px`
        },
        [responsive.Laptop]: {
            margin: `0 ${spacing.Gutter.Laptop}px  ${spacing.Gutter.Laptop}px  ${spacing.Gutter.Laptop}px`
        },
        [responsive.Desktop]: {
            margin: `0 ${spacing.Gutter.Desktop}px  ${spacing.Gutter.Desktop}px  ${spacing.Gutter.Desktop}px`
        }
    },
    logoLink: {
        display: 'block',
        lineHeight: 0,
        pointerEvents: 'initial'
    },
};

type Props =
    LogoProps &
    InjectedTransitionedContainerProps &
    StyledComponentProps<keyof typeof styles>;

const Logo: React.FunctionComponent<Props> = (props) => {
    const { classes, transitionedContainer: { move } } = props;
    return (

        <div className={classNames(classes!.logo, classes!.logoPositioning)}>
            <Link
                to={`/${Language}`}
                className={classes!.logoLink}
                // tslint:disable-next-line:jsx-no-lambda
                onClick={() => move('detail')}
                data-routed="true"
            >
                <img src={logo} alt="Logo image" />
            </Link>
        </div>
    );
};

export default withStyles(styles)(Logo);


// WEBPACK FOOTER //
// ./src/components/Logo.tsx